import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../store/actions/index';
import PsDropdown from '../UI/PsDropdown';
import * as modalTypes from '../Modals/modalTypes';
import Aux from '../../hoc/Aux';
import { useTranslation } from 'react-i18next';
import CalculationCoverageIcon from '../Modals/CalculationCoverageIcon';
import useCustomTranslation from '../../hooks/useCustomTranslation';
import BackgroundActive from '../../images/icon_revit.png';
import BackgroundInactive from '../../images/icon_revit_inactive.png';
import i18n from 'i18next';
import ReactDOM from 'react-dom';

const ProductSolution = (props) => {

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const ct = useCustomTranslation();

  const projectId = props.projectId;

  const [amount, setAmount] = useState(props.amount);
  const showEditProductSolutionModalHandler = () => {
    const modalProps = {open: true, formObject: {
                                      productSolutionId: props.productSolutionId,
                                      productSystemId: props.productSystemId,
                                      wizardConfiguration: props.wizardConfiguration,
                                      selectedItems: props.solutionItems,
                                      calculator: {
                                        hole_form: props.hole_form,
                                        hole_width: props.hole_width,
                                        hole_height: props.hole_height,
                                        hole_diameter: props.hole_diameter
                                      }
                                    }};

    const modalType = modalTypes.MODAL_EDIT_PRODUCT_SOLUTION;
    dispatch( actions.showModal({ modalProps, modalType }) );
  }

  const showEditProjectSolutionMetadataModalHandler = () => {
    const modalProps = {open: true, formObject: {
                                      productSolutionId: props.productSolutionId,
                                      description: props.description,
                                      notice: props.notice,
                                      hole_form: props.hole_form,
                                      hole_width: props.hole_width,
                                      hole_height: props.hole_height,
                                      hole_diameter: props.hole_diameter }};
    const modalType = modalTypes.MODAL_EDIT_PROJECT_SOLUTION_METADATA;
    dispatch( actions.showModal({ modalProps, modalType }) );
  }

  // copy
  // move

  const showDeleteProductSolutionModalHandler = () => {
    const modalProps = {open: true, formObject: {
                                      projectId: projectId,
                                      productSolutionId: props.productSolutionId}
                                    }
    const modalType = modalTypes.MODAL_DELETE_PRODUCT_SOLUTION;
    dispatch( actions.showModal({ modalProps, modalType }) );
  }

  const showRevitDownloadErrorModalHandler = () => {
    const modalProps = {open: true}
    const modalType = modalTypes.MODAL_DOWNLOAD_REVIT_ERROR;
    dispatch( actions.showModal({ modalProps, modalType }) );
  }

  const copyProductSolutionHandler = () => {
    dispatch( actions.copyProductSolution(props.productSolutionId) )
  }


  const generatePdf = () => {
    dispatch(actions.downloadProductSolutionPdfFromDb(props.productSolutionId, props.token ));
  }


  const thisProductSystem = useSelector(state => {
    return (actions.getReduxObjects(state.inventory.productSystems, props.wizardConfiguration.productSystem) || [])[0];
  })

  const generateShortinfoPdf = () => {
    dispatch(actions.downloadShortinfoPdf([], props.productSolutionId));
  }

  const generateSolutionBimZip = () => {
    dispatch(actions.downloadSolutionBimZip(props.productSolutionId, props.token));
  }

  const getLabelGenerateShortInfoPdf = () => {
    if (thisProductSystem.shortinfo_status === true) {
      return ct('wizard.product_system_items.dropdown.create_shortinfo_pdf')
    } else {
      return ct('wizard.product_system_items.dropdown.shortinfo_pdf_not_available')
    }
  }

  const getDisabledStatusGenerateShortInfoPdf = () => {
    return !thisProductSystem.shortinfo_status
  }


  const dropDownItems = () => {
    let items = [];
    items.push({
      action: showEditProjectSolutionMetadataModalHandler,
      text: t('productsolution.link.edit_details'), id: "edit1"
    });

    items.push({
      action: showEditProductSolutionModalHandler,
      text: t('productsolution.link.edit_solution'), id: "edit2"
    });

    items.push({
      action: copyProductSolutionHandler,
      text: t('productsolution.link.copy_solution'),
      id: "copy"
    });

    items.push({
      action: generateShortinfoPdf,
      text: getLabelGenerateShortInfoPdf(),
      disabled: getDisabledStatusGenerateShortInfoPdf(),
      id: "generateShortinfoPdf"
    });

    items.push({
      action: generatePdf,
      text: ct('wizard.product_system_items.dropdown.create_pdf'),
      id: "generatePdf"
    });

    if (ausschreibungenUrl() !== "") {
		  items.push({
        action: linkToAusschreibungenUrl,
        text: ct('wizard.product_system_items.dropdown.link_to_ausschreibungen'),
        id: "linkToAusschreibungenUrl"
      });
		}

    items.push({
      action: showDeleteProductSolutionModalHandler,
      text: t('productsolution.link.delete_solution'),
      id: "delete"
    });

    return items
  }

  const ausschreibungenUrl = () => {
		const topic = 'ausschreibungen';
		const info = thisProductSystem['product_system_urls'].find((x)=> ( x['topic'] === topic && x['locale'] === i18n.language));
    return (info !== undefined)? info.url : ""
  }

  const linkToAusschreibungenUrl = () => {
    window.open(ausschreibungenUrl(), "_blank")
  }

  const titleProductsystem = (thisProductSystem) =>{
    return (thisProductSystem !== undefined)? thisProductSystem.title : null
  }

  const handleSubstractAmount = () => {
    if (amount > 1) {
      setAmount(amount - 1)
      dispatch(actions.updateProductSolutionAmount(projectId, props.productSolutionId, amount - 1))
    }
  }

  const handleAddAmount = () => {
    setAmount(amount + 1)
    dispatch(actions.updateProductSolutionAmount(projectId, props.productSolutionId, amount + 1))
  }


  const isPresent = (x) => (x !== undefined && x !== "" && x !== null)

  const dropdownRef = useRef(null);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

  const updateDropdownPosition = () => {
    if (dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX
      });
    }
  };

  return (
    <div className="card card-task" style={{marginLeft: "20px"}}>
       <div className="card-body solution" >
          <div style={{display: "flex", alignItems: "center", justifyContent: "center", width: "100px"}}>
            <span 
              onClick={amount > 1 ? handleSubstractAmount : undefined} 
              className={props.color + " colLeft add-remove-handles" + (amount <= 1 ? "" : " hover-red")}  
              style={{width: "40px", opacity: amount <= 1 ? 0.5 : 1, cursor: amount <= 1 ? "default" : "pointer"}}
            >
              <i className={"material-icons icon-gray" + (amount <= 1 ? "" : " grow")}>remove_circle</i>
            </span>
            <span className={props.color}  style={{width: "40px", fontSize: "20px"}}>{props.amount}x</span>
            <span onClick={handleAddAmount}className={props.color + " colLeft add-remove-handles hover-green"}  style={{width: "40px"}}><i className="material-icons icon-gray grow">add_circle</i></span>
          </div>
          <div className="card-title">
             { (isPresent(props.description))?
               <h6>{props.description}</h6> : null
             }

             <span className="text-small">{titleProductsystem(thisProductSystem)}</span>
             <span className="text-small"> | </span>
             <span className="text-small">{t('wizard.steps.country.values.' + props.wizardConfiguration.country + '.long') }</span>
             <span className="text-small"> | </span>
             <span className="text-small">{t('wizard.steps.fwk.values.' + props.wizardConfiguration.fwk + '.long') }</span>

             <span className="text-small"> | </span>
             { (props.wizardConfiguration.location !== undefined && props.wizardConfiguration.location !== '')?
               <Aux>
               <span className="text-small">{t('wizard.steps.location.values.' + props.wizardConfiguration.location + '.long') }</span>
               <span className="text-small"> | </span></Aux> : null
              }

            { (props.wizardConfiguration.executionType !== undefined && props.wizardConfiguration.executionType !== '')?
              <Aux>
              <span className="text-small">{t('wizard.steps.execution_type.values.' + props.wizardConfiguration.executionType + '.long') }</span>
              <span className="text-small"> | </span></Aux> : null
             }

             <br></br>
             { (props.itemsCount === 1)?
               <Aux>
                  <span className="text-small">{props.itemsCount} { t('label.penetrations.singular') }</span>
                  <span className="text-small"> | </span>
               </Aux> : <Aux>
                  <span className="text-small">{props.itemsCount} { t('label.penetrations.plural') }</span>
                  <span className="text-small"> | </span>
                  </Aux>
              }



              { (isPresent(props.hole_form) && props.hole_form === 'square')?
                <Aux>
                <span className="text-small"><i className="material-icons hole-icon-square">aspect_ratio</i></span>
                <span className="text-small">{ props.hole_width } x { props.hole_height } mm</span>
                <span className="text-small"> | </span></Aux> : null
               }

             { (isPresent(props.hole_form) && props.hole_form === 'circle')?
               <Aux>
               <span className="text-small"><i className="material-icons hole-icon-square">hide_source</i></span>
               <span className="text-small">{ props.hole_diameter } mm</span>
               <span className="text-small"> | </span></Aux> : null
              }

             <span className="text-small">{props.token}</span>

             { (isPresent(props.calculation_schottbelegung_success) && props.calculation_schottbelegung_success === true)?
                <Aux>
                <span className="text-small"> | </span>
                <span className="text-small">{ props.calculation_schottbelegung_coverage }%</span>
                <CalculationCoverageIcon status={props.calculation_schottbelegung_status} />
                </Aux> : null
               }



             { (isPresent(props.notice))?
               <button className="btn btn-sm" style={{ fontSize: "x-small", backgroundColor: "#fff7dd", padding: "0.4em", background: "#c757d", marginLeft: "0.5em"}} onClick={showEditProjectSolutionMetadataModalHandler}>{ t('project.product_solution.text.schottinfo_vorhanden') }</button> : null
             }
          </div>

          <div className="card-meta">
            <div>&nbsp;&nbsp;</div>
            <div className="d-flex align-items-center">
               <div>&nbsp;&nbsp;&nbsp;&nbsp;</div>
            </div>
              <div className="d-flex align-items-center">
              { (props.hole_form === "square" || props.hole_form === 'circle')?
                 <button onClick={generateSolutionBimZip} className="btn btn-round" style={{borderRadius: "0%", margin: "7px 12px 0px 12px", paddingLeft: "4px", backgroundImage: `url(${BackgroundActive})`, backgroundRepeat: "no-repeat", backgroundColor: 'transparent'}}>
                 </button> :
                 <button onClick={showRevitDownloadErrorModalHandler} className="btn btn-round" style={{borderRadius: "0%", margin: "7px 12px 0px 12px", paddingLeft: "4px", backgroundImage: `url(${BackgroundInactive})`, backgroundRepeat: "no-repeat", backgroundColor: 'transparent'}}>
                 </button>
              }
              </div>

              <div className="d-flex align-items-center">
                <button onClick={showEditProductSolutionModalHandler} className="btn btn-round" style={{margin: "0px 12px 0px 12px", paddingLeft: "4px", background: "white"}}>
                <i className="material-icons">edit</i>
                </button>
              </div>

             <div ref={dropdownRef} onClick={updateDropdownPosition} className="dropdown card-options">
               <PsDropdown items={dropDownItems()} portalTarget={document.body} />
             </div>
          </div>


       </div>
    </div>

  )
}

export default ProductSolution;



// WEBPACK FOOTER //
// ./src/components/Project/ProductSolution.js